import { useUser } from '@/entities/user';

export const Prefix = {
	Yachting: '/yachting',
	Industrial: '/industrial',
} as const;

/**
 * Returns the current app prefix based on user context:
 * '/industrial' if isPlant === true
 * '/yachting'   if isPlant === false
 */
export const useAppPrefix = (): string => {
	const { isPlant } = useUser();

	return isPlant ? Prefix.Industrial : Prefix.Yachting;
};
